import {
  Box,
  Typography,
  Radio,
  FormControlLabel,
  Button,
  CircularProgress,
} from "@mui/material";
import BasicModal from "@/modules/common/components/modals/basic-modal";
import ModalHeader from "@/modules/common/components/modals/modal-header";
import useCopyZoomLink from "@/modules/lead-page/hooks/lead-info/lead-actions/copy-zoom-link.hook";
import { useEffect } from "react";
import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { showToast } from "@/modules/common/utils";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const CopyZoomLink = () => {
  const {
    zoomLinkModalOpen,
    setZoomLinkModalOpen,
    meetingTime,
    setMeetingTime,
    isGetZoomMeetingLoading,
    handleGetZoomLink,
    isSuccess,
    isError,
  } = useCopyZoomLink();

  useEffect(() => {
    if (isSuccess) {
      showToast({
        type: ToastType.SUCCESS,
        message: "Zoom meeting created successfully",
        toastId: TOAST_IDS.ZOOM_MEETING_SUCCESS,
        options: {
          position: "bottom-left",
          autoClose: 3000,
        },
      });
    }

    if (isError) {
      showToast({
        type: ToastType.ERROR,
        message: "Failed to create zoom meeting",
        toastId: TOAST_IDS.ZOOM_MEETING_ERROR,
        options: {
          position: "bottom-left",
          autoClose: 3000,
        },
      });
    }
  }, [isSuccess, isError]);
  return (
    <>
      <BasicModal
        width={400}
        open={zoomLinkModalOpen}
        setOpen={setZoomLinkModalOpen}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: "32px",
          }}
        >
          <ModalHeader
            headerText="Create Zoom Meeting"
            handleClose={() => setZoomLinkModalOpen(false)}
          />
          <FormControlLabel
            control={
              <Radio
                checked={meetingTime === "LATER"}
                onChange={() => setMeetingTime("LATER")}
                value="30 minutes"
              />
            }
            label="Start after 30 minutes"
          />
          <FormControlLabel
            control={
              <Radio
                checked={meetingTime === "INSTANT"}
                onChange={() => setMeetingTime("INSTANT")}
                value="instant"
              />
            }
            label="Instant meeting"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleGetZoomLink}
            disabled={isGetZoomMeetingLoading}
          >
            {isGetZoomMeetingLoading ? (
              <CircularProgress size={20} />
            ) : (
              "Create meeting"
            )}
          </Button>
        </Box>
      </BasicModal>

      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          ":hover": {
            backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
          },
        }}
        onClick={() => setZoomLinkModalOpen(true)}
      >
        <Typography
          sx={{
            color: nawyTheme.nawy.colors.semantic.text.primary,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          Get Zoom Link
        </Typography>
      </Box>
    </>
  );
};

export default CopyZoomLink;
